<template>
  <div class="flex bg-white">
    <Tab />
    <AdministrationNavigation />
    <div class="is-teacher flex min-h-screen w-full flex-col justify-between">
      <div class="flex min-h-screen w-full flex-col justify-between pb-8 pt-6 max-lg:pb-18 lg:pt-10 xl:pt-12">
        <slot />
      </div>
      <AppFooter />
      
    </div>
  </div>
</template>

<script setup lang="ts">
const icon = useFavicon()

icon.value = '/favicon-teacher.svg'
</script>
